import React, { useEffect, useState } from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from "../../services/data.service";

const MenuItems: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/menuitems')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function add() {
        navigate('/plm/appconfig/menuitems/add', { state: { title: 'New menu item', fromMenu: false } });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/menuitems/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Begindate', dataProp: 'beginDate', dataType: 'date' },
        { title: 'Enddate', dataProp: 'endDate', dataType: 'date' },
        { title: 'Title', dataProp: 'title', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Parent menu', dataProp: 'parentMenuItem', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Application function', dataProp: 'applicationFunction', filterInfo: { filterType: 'Textbox' } },

    ];
    if (isAuthorizedFor(ApplicationFunctions.EditBrand)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: add }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return (
        <>
            <div className='main-content'>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card title='Menu items'
                                content={
                                    <DataTable
                                        name='dtMenuItems'
                                        tableData={data}
                                        colInfos={colInfos}
                                        navigateTitle='Menu item'
                                        navigateUrl='/plm/appconfig/menuitem/'
                                    />
                                }
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
export default MenuItems;